import { render, staticRenderFns } from "./FontLoader.vue?vue&type=template&id=281b5551&"
import script from "./FontLoader.vue?vue&type=script&lang=js&"
export * from "./FontLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports